module.exports = __webpack_public_path__ + "static/media/Recency Effect.f789dd7f.jpg";